import { Application } from "@hotwired/stimulus"
import InvestorSurveyController from "controllers/investor_survey_controller"

const app = Application.start()
app.register("investor-survey", InvestorSurveyController)
